import { type FunctionComponent } from "react";

import proEstLogo from "images/Common/ProEst_logo.png";

import { type IBTIconProps } from "../BTIcon.types";

export const BTIconDeprecatedProEst: FunctionComponent<IBTIconProps> = (baseProps) => {
    return <img alt="" src={proEstLogo} style={baseProps.style} className={baseProps.className} />;
};
